# TODO

# Load farm answers async, and show checkbox once loaded.
# Don't send all created/updated dates to client (performance)
# fileInfo to show used files
# Use RESTful save
# Header fields?
# areasObj back at server
# Better "Loading..." message
# Dynamic checkbox progress boxes
# Return key in numeric field: toggles subanswers for another question?

# Backbone models and views
{Model, Collection, View} = aqnz


class App
  
  constructor: ->
    
    console.log "A+ checklist"
    console.log aqnz
    
    @container = $ ".checklist-body"
    
    # Extract data from aqnz
    @setRegions()
    {checklistId, files, updated, answersPrevYear} = aqnz  # TODO: won't need files later
    
    @fileCollection = new Collection.Files  # Uses aqnz.files
    aqnz.fileCollection = @fileCollection  # Used by Model.Answer
    
    @sectionCollection = new Collection.Sections null, {sections: aqnz.sections} # Uses aqnz.areas/farms
    
    # TODO: won't need files later
    @checklist = new Model.Checklist {checklistId, @sectionCollection, files, updated, answersPrevYear}
    
    $(".loading-message").empty()
    
    new View.Checklist
      el: @container
      model: @checklist
    
    new View.QuestionHelp
    
    $('.grower-users').show()
    $('.checklist-dates').show()
    $('.checklist-header').show()
    $('.checklist-buttons-column').show()
    
  setRegions: ->
    r = []
    regions = []
    for area in aqnz.areas
      region = area.region
      unless region.name in r
         r.push region.name
         regions.push region
    aqnz.regions = regions
  



new App